import React, { useState, useRef, useEffect, useContext } from "react";
import { Card, Form, Row, Col, Button, Table, Badge } from "react-bootstrap";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { AiOutlineFilePdf } from "react-icons/ai";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { ToastContainer, toast } from "react-toastify";
import ApproveModel from "../../components/common/ApproveModel";
import { FaTimes, FaPlus, FaCheck, FaSync, FaBook, FaArrowLeft } from "react-icons/fa"; // classic cross icon
import {
  formateDatemdy,
} from "../../utils/Helper";
const Generate_topic = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };
  const FileInputRef = useRef(null);
  const [pdfFileName, setPdfFileName] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [topicName, setTopicName] = useState("");
  const [errors, setErrors] = useState({});
  const [errorA, setErrorA] = useState([]);
  const [data, setData] = useState([]);
  const [requestId, setRequestId] = useState("");
  const [load, setLoad] = useState(false);
  const [loadApprove, setLoadApprove] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [showAppr, setShowAppr] = useState(false);

  // PDF change handler
  const onPdfChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // validate MIME type
    if (file.type !== "application/pdf") {
      setErrors({ pdf: "Please upload a PDF file only." });
      setPdfFile(null);
      setPdfFileName(null);
      FileInputRef.current.value = null; // reset input
      return;
    }

    if (file) {
      setPdfFile(file);
      setPdfFileName(file.name);
      setTopicName("");
    }
    setErrors({});
  };

  // Add decryption helper function
  const decryptId = (encryptedId) => {
    try {
      return decodeURIComponent(atob(encryptedId));
    } catch (error) {
      console.error("Decryption error:", error);
      return null;
    }
  };

  // Get encrypted courseId from query params and decrypt it
  const [searchParams] = useSearchParams();
  const encryptedCourseId = searchParams.get('id');
  const courseId = decryptId(encryptedCourseId);

  // Add state for course data
  const [courseData, setCourseData] = useState(null);
  const [loadingCourse, setLoadingCourse] = useState(false);

  // Add useEffect to fetch course details
  useEffect(() => {
    if (courseId) {
      fetchCourseDetails(courseId);
    } else if (encryptedCourseId) {
      showToast("Invalid course ID", "error");
      navigate("/admin/course");
    }
  }, [courseId]);

  // Add function to fetch course details
  const fetchCourseDetails = async (id) => {
    setLoadingCourse(true);
    try {
      const response = await APIServices.get(
        `/admin/courses/${id}`,
        headers
      );
      if (response?.data?.status === true) {
        setCourseData(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching course details:", error);
      showToast("Error fetching course details", "error");
    } finally {
      setLoadingCourse(false);
    }
  };

  const handleNameChange = (e) => {
    setTopicName(e.target.value);
    setErrors({});
  };

  const validateForm = () => {
    let newErrors = {};

    if (topicName === "" && !pdfFile) {
      newErrors.name = "Text is required if no PDF is uploaded for generate topic.";
    }
    if (pdfFile === null && !topicName) {
      newErrors.pdf = "PDF file is required if no text is entered for generate topic";
    }

    setErrors(newErrors);
    return newErrors;
  };

  const handleGenerate = async (e) => {
    e.preventDefault();

    let newRow = new FormData();

    if (topicName && pdfFile) {
      newRow.append("file", pdfFile);
      newRow.append("text", topicName);
    } else if (topicName) {
      newRow.append("text", topicName);
    } else if (pdfFile) {
      newRow.append("file", pdfFile);
    }

    if (courseId) {
      newRow.append("course_id", courseId);
    }

    // for (let pair of newRow.entries()) {
    //   console.log(pair[0] + ": " + pair[1]);
    // }
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setLoad(true);
      try {
        const response = await APIServices.post(`/admin/topics/add`, newRow, {
          "content-type": "multipart/form-data",
          ...headers,
        });
        if (response?.data?.status === true) {
          showToast(response?.data?.message || "Success", "success");
          setData(response?.data?.data?.topics);
          setRequestId(response?.data?.data?.request_id);
          setLoad(false);
        } else {
          showToast(
            response?.data?.message || "Something went wrong.",
            "error"
          );
          setLoad(false);
        }
      } catch (error) {
        showToast("Something went wrong.", "error");
      } finally {
        setLoad(false);
      }
    }
  };

  const handleReset = () => {
    setTopicName("");
    setPdfFileName(null);
    setErrors({});
    setErrorA([]);
    setRequestId("");
    setData([]);
    setLoad(false);
    setLoadApprove(false);
  };

  // Delete row
  const handleDelete = (index) => {
    const updatedData = data.filter((_, i) => i !== index);
    setData(updatedData);
  };

  // Handle input change
  const handleChange = (index, value) => {
    const updated = [...data];
    updated[index] = value;
    setData(updated);

    // clear error for this index if fixed
    const updatedErrors = [...errorA];
    updatedErrors[index] = value.trim() === "" ? "Please enter topic name" : "";
    setErrorA(updatedErrors);
  };

  // Add new empty input
  const handleAdd = () => {
    setData([...data, ""]);
  };

  // Remove input by index
  const handleRemove = (index) => {
    const updated = data.filter((_, i) => i !== index);
    setData(updated);
    setErrorA(errorA.filter((_, i) => i !== index));
  };

  // Approve → log final object
  const handleApprove = async () => {
    const updatedErrors = data.map((t) =>
      t.trim() === "" ? "Please enter topic name" : ""
    );
    setErrorA(updatedErrors);
    if (updatedErrors.some((err) => err !== "")) {
      return;
    }
    setLoadApprove(true);
    const payload = {
      name: data,
      request_id: requestId,
      course_id: courseId  // Add courseId here
    };

    try {
      const response = await APIServices.put(
        `/admin/topics/approve`,
        payload,
        headers
      );
      if (response?.data?.status === true) {
        showToast(response?.data?.message || "Success", "success");
        setLoadApprove(false);
        setShowAppr(false);
        setTimeout(() => {
          navigate(`/admin/course-detail/${courseId}?tab=topics`);
        }, 2000);
      } else {
        showToast(response?.data?.message || "Something went wrong.", "error");
        setLoadApprove(false);
      }
    } catch (error) {
      showToast("Something went wrong.", "error");
    } finally {
      setLoadApprove(false);
    }
  };
  const clearFile = () => {
    setPdfFile(null);
    setPdfFileName(null);
    setErrors({});
    FileInputRef.current.value = null;
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  return (
    <>

      <div className="generate_topic">
        <div className="gtheader d-flex justify-content-between align-items-center mb-2">
          <h1 className="font_blue_18 font-600">
            {id ? "Edit Topic" : "Generate Topic"}
          </h1>

          <Button
            variant="outline-secondary"
            onClick={() => navigate("/admin/course-detail/" + courseData.id)}
          >
            <FaArrowLeft className="me-1" /> Back
          </Button>
        </div>
        {/* Course Information Card */}
        {courseData && (
          <Card className="mb-4 course-info-card">
            <Card.Body>
              <Row>
                {/* Left Side - Image */}
                <Col md={3} className="text-center">
                  {courseData.image ? (
                    <img
                      src={courseData.image}
                      alt={courseData.title}
                      style={{
                        width: '100%',
                        maxWidth: '150px',
                        height: '150px',
                        objectFit: 'cover',
                        borderRadius: '8px'
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: '150px',
                        height: '150px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto'
                      }}
                    >
                      <FaBook size={60} color="#999" />
                    </div>
                  )}
                </Col>

                {/* Right Side - Course Details */}
                <Col md={9}>
                  <h4 className="mb-2">{courseData.title}</h4>
                  <p className="text-muted mb-3">
                    <strong>Course ID:</strong> {courseData.unique_course_id}
                  </p>

                  <Row>
                    {/* Duration */}
                    <Col md={6} className="mb-2">
                      <div className="text-muted small">Duration</div>
                      <div className="fw-semibold">{courseData.duration}</div>
                    </Col>

                    {/* Language */}
                    <Col md={6} className="mb-2">
                      <div className="text-muted small">Language</div>
                      <div className="fw-semibold">{courseData.language}</div>
                    </Col>

                    {/* Expiry Date */}
                    <Col md={6} className="mb-2">
                      <div className="text-muted small">Expiry Date</div>
                      <div className="fw-semibold">
                        { formateDatemdy(courseData.expiry_date)}
                      </div>
                    </Col>

                    {/* Status */}
                    <Col md={6} className="mb-2">
                      <div className="text-muted small">Status</div>
                      <div className="fw-semibold">
                        <Badge bg={courseData.status === "Active" ? "success" : "danger"}>
                          {courseData.status}
                        </Badge>
                      </div>
                    </Col>
                  </Row>

                  {/* Sub Title */}
                  <div className="mt-3">
                    <div className="text-muted small">Sub Title</div>
                    <div className="fw-semibold">{courseData.sub_title || 'N/A'}</div>
                  </div>

                  {/* Grades List */}
                  <div className="mt-3">
                    <div className="text-muted small mb-2">Grades Offered</div>
                    <div className="d-flex flex-wrap gap-1">
                      {courseData.grade_names?.length > 0 ? (
                        courseData.grade_names.map((grade, idx) => (
                          <Badge key={idx} bg="info" className="me-1 mb-1 px-3 py-2">
                            {grade}
                          </Badge>
                        ))
                      ) : (
                        <span className="text-muted">No grades assigned</span>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        )}

        <Card className="add_channel_form">
          <Card.Body>
            <Form onSubmit={handleGenerate}>
              <Row className="align-items-center">
                {/* Topic Name */}
                <Col md={5} lg={5}>
                  <Form.Group controlId="topicName">
                    <Form.Label className="font_blue_14 font-500 mb-2">
                      Generate By Text
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Text"
                      value={topicName}
                      onChange={handleNameChange}
                      isInvalid={!!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.name}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={2} lg={2}>
                  <p className="or text-center font_blue_20 font-600 d-flex align-items-center justify-content-center">
                    <span>OR</span>
                  </p>
                </Col>

                {/* PDF Upload */}
                <Col md={5} lg={5}>
                  <div className="d-flex flex-column align-items-start">
                    <p className="font_blue_14 font-500 mb-2 form-label">
                      Generate By PDF
                    </p>
                    <div className="w-100 upload_pdf">
                      <label
                        htmlFor="pdf-upload"
                        className={`form-control d-flex align-items-center gap-2 ${errors.pdf ? "is-invalid" : ""
                          }`}
                      >
                        <AiOutlineFilePdf size={30} color="#d32f2f" />
                        {pdfFileName && (
                          <span className="uploaded-pdf-name">
                            {pdfFileName}
                          </span>
                        )}
                      </label>
                      {/* {pdfFile && (
                       <span className="clear_icon" onClick={clearFile}>
                         ❌
                       </span>
                     )} */}
                      <Form.Control
                        type="file"
                        id="pdf-upload"
                        className="d-none"
                        accept="application/pdf"
                        onChange={onPdfChange}
                        ref={FileInputRef}
                        isInvalid={!!errors.pdf}
                      />
                      {errors.pdf && (
                        <div className="invalid-feedback d-block">
                          {errors.pdf}
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>

              {errors.general && (
                <div className="text-danger mt-2">{errors.general}</div>
              )}

              {/* Action Buttons */}
              <div className="d-flex justify-content-center gap-2 mt-5">
                <Button variant="outline-primary" onClick={handleReset}>
                  Reset
                </Button>
                <Button
                  type="submit"
                  disabled={requestId || load ? true : false}
                  className="btn red_button"
                >
                  {load ? "Processing..." : "Generate"}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>

        <div className="generated_topics mt-5">
          {data?.length > 0 && (
            <div className="todoList_table">
              <h5 className="font_blue_18 font-600 mb-3">Generated Topics</h5>
              <div className="topics_box">
                {data?.map((topic, index) => (
                  <div key={index} className="topic_row position-relative">
                    <input
                      type="text"
                      className={`topic_input ${errorA[index] ? "error" : ""}`}
                      placeholder="Enter topic"
                      value={topic}
                      onChange={(e) => handleChange(index, e.target.value)}
                    />
                    <button
                      className="remove_btn"
                      disabled={data?.length === 1}
                      onClick={() => handleRemove(index)}
                    >
                      <FaTimes size={24} color="red" />
                    </button>
                    {errorA[index] && (
                      <span className="error_text">{errorA[index]}</span>
                    )}
                  </div>
                ))}
              </div>

              <div className="buttons_group">
                <button className="add_btn" onClick={handleAdd}>
                  <FaPlus size={16} color="white" /> Add More
                </button>
                <button
                  className="approve_btn"
                  onClick={() => setShowAppr(true)}
                  disabled={loadApprove}
                >
                  {loadApprove ? (
                    "Processing..."
                  ) : (
                    <>
                      <FaCheck size={16} color="white" /> Approve
                    </>
                  )}
                </button>
                <button className="regenerate_btn" onClick={handleGenerate}>
                  <FaSync size={14} color="white" className="me-1" /> Regenerate
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <ToastContainer />
      <ApproveModel
        show={showAppr}
        handleClose={() => setShowAppr(false)}
        handle={handleApprove}
        type="topics"
      />
    </>
  );
};

export default Generate_topic;
